import type { Milestone } from '@altyor-kronos/shared-types';
import { usePolledResource } from '../../core/data/usePolledResource';
import { apiList } from '../../core/data/restClient';

export type MilestoneRow = Milestone & { id: string; projectId: string };

/**
 * Tous les jalons, tous projets confondus — la portée est appliquée par le
 * serveur (`/api/milestones` : tout pour admin/direction, sinon les projets
 * managés). La réponse porte quelques milliers de documents.
 */
export function useAllMilestones(enabled: boolean) {
  const { rows, loading, error } = usePolledResource<MilestoneRow>(
    enabled ? 'all-milestones' : null,
    () => apiList<MilestoneRow>('/milestones'),
  );
  return { rows, loading, error };
}
